<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
    <div class="search-container">
        <div class="search-column">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input [(ngModel)]="search.name" matInput>
            </mat-form-field>

          <ac-input-container label="Origin">
            <ac-select [(acModel)]="search.origin"
                       [items]="search.originOptions"
                       [allowClear]="true"
                       [multiple]="false"
                       [groupBy]="'type'"
                       [bindValue]="null"
                       [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>
    </div>
</arm-dialog>
